var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"styled-keyword__container",style:({ 'background-color': `${_vm.$attrs.color || 'rgb(57, 57, 57)'}` })},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }